import { client } from '@api/client';
import { URL } from '@api/urls';

import { TBandDTO } from '@interfaces/cells/dto/cellsDTO';

const { cellsUsedBands } = URL;

export const getCellsUsedBands = (): Promise<Array<TBandDTO>> => {
	return client.get(cellsUsedBands);
};
